export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/step-register.eb1c2842-eaa5f0.png";